// 二屏打点+滚动打点
import safeLog from '@alife/bc-safe-log';

function scrollDot() {
  let taskDone = false;
  let hasScroll = false;
  function scrollHandler() {
    if (taskDone) {
      return;
    }
    const scrollTop = parseInt(document.documentElement.scrollTop);
    const clientHeight = parseInt(document.documentElement.clientHeight);
    if (scrollTop > 2 * clientHeight) {
      taskDone = true;
      window.removeEventListener('scroll', scrollHandler);
      safeLog('/sc.details.secondScreen', 'EXP');
    }
  }
  function pageHasScroll() {
    if (hasScroll) {
      return;
    }
    hasScroll = true;
    window.removeEventListener('scroll', pageHasScroll);
    safeLog('/sc.details.hasScroll', 'EXP');
  }
  window.addEventListener('scroll', scrollHandler);
  window.addEventListener('scroll', pageHasScroll);
}

export default scrollDot;
